import SchoolHero from "./SchoolHero/SchoolHero";
import Ecosystem from "./Ecosystem/Ecosystem";
import Timeline from "./Timeline/Timeline";
import Services from "./Services/Services";
import TrainingSupport from "./TrainingSupport/TrainingSupport";
import CTAForm from "../CTAForm/CTAForm";

const SchoolProgrammes = () => {
  return (
    <>
      <SchoolHero />
      <Ecosystem />
      <Timeline />
      <Services />
      <TrainingSupport />
      <CTAForm />
    </>
  );
};

export default SchoolProgrammes;
